export default __webpack_public_path__ + "static/media/Checkbox.88ce4584.svg";